import React from 'react';
import { View, StyleSheet } from 'react-native';
import BaseText from '../BaseText';
import { CommonStyles, Color, CommonProperties } from '../../styles';

const PNRInfo = ({ label, value, style, ...rest }) => {
  return (
    <View style={[styles.wrap, style]} {...rest}>
      <BaseText style={styles.label}>{label}</BaseText>
      <BaseText style={CommonStyles.h1}>{value}</BaseText>
    </View>
  );
};

const styles = StyleSheet.create({
  wrap: {
    backgroundColor: 'white',
    ...CommonProperties.p3,
  },
  label: {
    color: Color.grayText2,
  },
});

export default PNRInfo;
